// FormTextField.jsx
import React from "react";
import { Typography, TextField } from "@mui/material";

const FormTextField = ({ label, value, onChange, ...props }) => {
  return (
    <div>
      {label && <Typography sx={{ mb: 1 }}>{label}</Typography>}
      <TextField
        fullWidth
        value={value}
        onChange={onChange}
        sx={{ mb: 3 }}
        variant="outlined"
        size="small"
        {...props}
      />
    </div>
  );
};

export default FormTextField;
